import React from 'react'
import PropTypes from 'prop-types'
import {isItuOrPegasus} from "wipi-common/src/lib/util"
import {useI18nContext} from "../i18n/I18nContext"
import Text from "../i18n/Text"

export default function ContinueInBrowser({serviceCenterInBusiness, caseInfo, isVideoSupported}) {
    const context = useI18nContext()
    if ((!serviceCenterInBusiness && !isItuOrPegasus()) || !isVideoSupported) {
        return null
    }

    return <p className="text-small mb-5 continue-in-browser" data-test-id="05880657-0c78">
            <Text k="startVideo.browser.preLink" />
            <a className="link" href={'/user/videochat/?v=' + caseInfo.caseId+((context)?'&lang='+context.lang:'')}>
                <Text k="startVideo.browser.link" />
            </a>
        </p>
}

ContinueInBrowser.propTypes = {
    serviceCenterInBusiness: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
    isVideoSupported: PropTypes.bool,
    caseInfo: PropTypes.shape({
        caseId: PropTypes.string.isRequired,
        clientId: PropTypes.string,
        branding: PropTypes.string,
        legalNote: PropTypes.object
    }).isRequired
}
